import { useContext } from 'react';
import StatusDataContext from '../context/StatusDataContext';
function useStatusDataContext() {
    return useContext(StatusDataContext);
}
export default useStatusDataContext;
